import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const FolderShareDialogSkeleton: React.FC = () => {
  return (
    <div className="grid gap-4">
      <div className="flex gap-2">
        <Skeleton className="h-9 flex-1" />
        <Skeleton className="h-9 w-[140px]" />
        <Skeleton className="h-9 w-20" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
        <Skeleton className="h-10 w-full" />
      </div>
      <Skeleton className="h-8 w-64" />
    </div>
  )
}

export default FolderShareDialogSkeleton
